var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fileGallery h-100" }, [
    _c(
      "div",
      { staticClass: "h-100" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeIndex != 0,
                expression: "activeIndex != 0",
              },
            ],
            staticClass: "backward fileGalleryButton",
            on: { click: _vm.backward },
          },
          [_c("i", { staticClass: "inticon-angle-left" })]
        ),
        _vm._v(" "),
        _c(
          "carousel-3d",
          {
            ref: "fileGallery",
            staticClass: "m-0",
            attrs: { height: _vm.height, width: _vm.width },
            on: { "after-slide-change": _vm.onAfterSlideChange },
          },
          _vm._l(_vm.files, function (file, fileIndex) {
            return _c(
              "slide",
              {
                key: file.id,
                staticClass: "d-flex align-items-center text-center",
                class: _vm.slideClasses(file),
                attrs: { index: fileIndex },
              },
              [
                file.thumbnailUrl
                  ? _c("span", [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isImageVisible(
                              fileIndex,
                              _vm.activeIndex
                            ),
                            expression:
                              "isImageVisible(fileIndex, activeIndex)",
                          },
                        ],
                        attrs: {
                          alt: file.fileName,
                          loading: "lazy",
                          src: file.thumbnailUrl,
                        },
                      }),
                    ])
                  : _c("span", { staticClass: "align-self-center m-auto" }, [
                      _vm._v(
                        "\n                    Vorschau für diesen Dateityp nicht verfügbar.\n                "
                      ),
                    ]),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeIndex != _vm.lastFileIndex,
                expression: "activeIndex != lastFileIndex",
              },
            ],
            staticClass: "forward fileGalleryButton",
            on: { click: _vm.forward },
          },
          [_c("i", { staticClass: "inticon-angle-right" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "open fileGalleryButton",
            attrs: { title: "Datei ansehen" },
            on: { click: _vm.open },
          },
          [_c("i", { staticClass: "inticon-search" })]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }